import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SofboxModule } from '../sofbox/sofbox.module';
import { IndexEdComponent } from './index/index.component';
import { SliderModule } from './components/slider/slider.module';
import { FeaturesComponent } from './components/features/features.component';
import { TipsTrickComponent } from './components/tips-trick/tips-trick.component';
import { TipsTrick1Component } from './components/tips-trick1/tips-trick1.component';
import { PortfolioComponent } from './components/portfolio/portfolio.component';
import { PostComponent } from './components/post/post.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { About2Component } from './components/about2/about2.component';
const routes: Routes = [
  {
    path: '',
    component: IndexEdComponent,
  }
];

@NgModule({
  declarations: [About2Component,IndexEdComponent, FeaturesComponent, TipsTrickComponent, TipsTrick1Component, PortfolioComponent, PostComponent,PricingComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SliderModule,
    SofboxModule
  ]
})
export class SaasTwoModule { }
